module.exports = __webpack_public_path__ + "img/asset10x1.17afd9ac.png";